<div class="custom-date-picker">
  <div class="date-range">
    <div class="date-range-label">{{ !singleDateSelection ? 'Date Range' : '' }}</div>
     <div #dateRangeDisplay class="date-range-display" (click)="toggleCalendar($event)" (paste)="onPaste($event)" [class.open]="isOpen" [class.paste-success]="pasteSuccess" [class.disabled]="isDisabled" [style.pointer-events]="isDisabled ? 'none' : 'auto'" [style.opacity]="isDisabled ? '0.6' : '1'">
       <span 
         #dateRangeText
         class="date-range-text" 
         *ngIf="!singleDateSelection" 
         [class.placeholder]="!startDate || !endDate">
         {{ (startDate && endDate) ? (formatDate(startDate) + ' to ' + formatDate(endDate)) : 'Select date range' }}
       </span>
       <span 
         #dateRangeText
         class="date-range-text" 
         *ngIf="singleDateSelection" 
         [class.placeholder]="!startDate">
         {{ startDate ? formatDate(startDate) : 'Select date' }}
       </span>
      <span class="date-range-icon">
        <img class="calendar-icon" src="assets/icons/job-planning/picker.svg" alt="calendar">
      </span>
    </div>
  </div>

  <div #calendarPopup class="calendar-popup" *ngIf="isOpen" (click)="$event.stopPropagation()">
    <!-- <div class="top-inputs" *ngIf="!singleDateSelection; else singleTopInputs">
      <div class="input-field">
        <div class="label">Start</div>
        <div class="input-box">{{ formatDateForInput(selectionStart || startDate) }}</div>
      </div>
      <div class="dash">–</div>
      <div class="input-field">
        <div class="label">End</div>
        <div class="input-box">{{ formatDateForInput(selectionEnd || endDate) }}</div>
      </div>
    </div> -->
    <ng-template #singleTopInputs>
      <div class="top-inputs single">
        <div class="input-field">
          <div class="label">Date</div>
          <div class="input-box">{{ formatDateForInput(selectionStart || startDate) }}</div>
        </div>
      </div>
    </ng-template>
    <!-- Calendar Header with Navigation -->
    <div class="calendar-header">
      <button type="button" class="nav-btn prev" (click)="currentView === calendarView.year ? navigateYearRange('prev') : (currentView === calendarView.month ? null : previousMonth($event))">
        &lt;
      </button>
      <div class="month-year-selector">
        <!-- Year View Title -->
        <span *ngIf="currentView === calendarView.year" class="view-title">
          {{ getCurrentViewTitle() }}
        </span>
        <!-- Month View Title -->
        <span *ngIf="currentView === calendarView.month" class="view-title clickable" (click)="navigateToYearView()">
          {{ getCurrentViewTitle() }}
        </span>
        <!-- Day View Title -->
        <div *ngIf="currentView === calendarView.day" class="day-view-header">
          <span class="month-part clickable" (click)="navigateToMonthView()">{{ months[currentMonth] }}</span>
          <span class="year-part clickable" (click)="navigateToYearView()">{{ currentYear }}</span>
        </div>
      </div>
      <button type="button" class="nav-btn next" (click)="currentView === calendarView.year ? navigateYearRange('next') : (currentView === calendarView.month ? null : nextMonth($event))">
        &gt;
      </button>
    </div>

    <!-- Calendar Content -->
    <div class="calendar-content">
      <!-- Year Selection Grid -->
      <div *ngIf="currentView === calendarView.year" class="year-grid">
        <div *ngFor="let yearRow of getYearsInRows()" class="year-row">
          <div 
            *ngFor="let year of yearRow" 
            class="year-item"
            [class.current-year]="isCurrentYear(year)"
            [class.selected-year]="year === currentYear"
            (mousedown)="onYearClick(year, $event)">
            {{ year }}
          </div>
        </div>
      </div>

      <!-- Month Selection Grid -->
      <div *ngIf="currentView === calendarView.month" class="month-grid">
        <div *ngFor="let monthRow of getMonthsInRows()" class="month-row">
          <div 
            *ngFor="let month of monthRow" 
            class="month-item"
            [class.current-month]="isCurrentMonth(month.index)"
            [class.selected-month]="month.index === currentMonth"
            (mousedown)="onMonthClick(month.index, $event)">
            {{ month.name }}
          </div>
        </div>
      </div>

      <!-- Day Selection Grid (existing calendar) -->
      <div *ngIf="currentView === calendarView.day" class="calendar-grid">
        <div class="weekdays">
          <div class="weekday" *ngFor="let day of weekDays">{{ day }}</div>
        </div>

        <div class="days">
          <div 
            *ngFor="let day of calendarDays" 
            class="day" 
            [class.outside-month]="!day.inCurrentMonth" 
            [class.today]="day.isToday" 
            [class.selected]="day.isSelected && day.date.getTime() === selectionStart?.getTime()" 
            [class.in-range]="isDateInRange(day.date) && day.date.getTime() !== selectionStart?.getTime() && day.date.getTime() !== selectionEnd?.getTime()" 
            [class.range-start]="day.date.getTime() === selectionStart?.getTime() && selectionStart?.getTime() !== selectionEnd?.getTime()" 
            [class.range-end]="day.date.getTime() === selectionEnd?.getTime() && selectionStart?.getTime() !== selectionEnd?.getTime()" 
            [class.selected-day]="day.isSelectedEnd"
            [class.disabled]="!day.isSelectable"
            (click)="onDateClick(day, $event)">
            {{ day.day }}
          </div>
        </div>
      </div>
    </div>

    <!-- Time Selectors -->
    <div *ngIf="enableTimeSelection && currentView === calendarView.day" class="time-selectors">
      <ng-container *ngIf="singleDateSelection; else rangeTimeSelectors">
        <div class="time-selector-section single-mode" style="justify-content: center;">
          <!-- Single Time -->
          <div class="time-selector from" 
               [class.active]="activeTimeSelector === 'from'"
               (click)="setActiveTimeSelector('from', $event)">
            <div class="time-label">Time</div>
            <div class="time-row">
              <div class="time-inputs">
                <input 
                  type="text" 
                  class="time-input hour-input" 
                  [placeholder]="fromTime.hour.toString().padStart(2, '0')"
                  maxlength="2"
                  (keydown)="onTimeInputKeydown($event, 'hour', 'from')"
                  (blur)="onTimeInputBlur($event, 'hour', 'from')"
                  (focus)="onTimeInputFocus($event, 'hour', 'from')"
                  (click)="$event.stopPropagation()">
                <span class="time-separator">:</span>
                <input 
                  type="text" 
                  class="time-input minute-input" 
                  [placeholder]="fromTime.minute.toString().padStart(2, '0')"
                  maxlength="2"
                  (keydown)="onTimeInputKeydown($event, 'minute', 'from')"
                  (blur)="onTimeInputBlur($event, 'minute', 'from')"
                  (focus)="onTimeInputFocus($event, 'minute', 'from')"
                  (click)="$event.stopPropagation()">
              </div>
              <div class="am-pm-toggle" *ngIf="use12Hours">
                <button type="button" class="am" [class.active]="amPm.from === 'AM'" (click)="onToggleAmPm('from', 'AM', $event)">AM</button>
                <button type="button" class="pm" [class.active]="amPm.from === 'PM'" (click)="onToggleAmPm('from', 'PM', $event)">PM</button>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-template #rangeTimeSelectors>
        <div class="time-selector-section">
          <!-- From Time -->
          <div class="time-selector from" 
               [class.active]="activeTimeSelector === 'from'"
               (click)="setActiveTimeSelector('from', $event)">
            <div class="time-label">Start</div>
            <div class="time-row">
              <div class="time-inputs">
                <input 
                  type="text" 
                  class="time-input hour-input" 
                  [placeholder]="fromTime.hour.toString().padStart(2, '0')"
                  maxlength="2"
                  (keydown)="onTimeInputKeydown($event, 'hour', 'from')"
                  (blur)="onTimeInputBlur($event, 'hour', 'from')"
                  (focus)="onTimeInputFocus($event, 'hour', 'from')"
                  (click)="$event.stopPropagation()">
                <span class="time-separator">:</span>
                <input 
                  type="text" 
                  class="time-input minute-input" 
                  [placeholder]="fromTime.minute.toString().padStart(2, '0')"
                  maxlength="2"
                  (keydown)="onTimeInputKeydown($event, 'minute', 'from')"
                  (blur)="onTimeInputBlur($event, 'minute', 'from')"
                  (focus)="onTimeInputFocus($event, 'minute', 'from')"
                  (click)="$event.stopPropagation()">
              </div>
              <div class="am-pm-toggle" *ngIf="use12Hours">
                <button type="button" class="am" [class.active]="amPm.from === 'AM'" (click)="onToggleAmPm('from', 'AM', $event)">AM</button>
                <button type="button" class="pm" [class.active]="amPm.from === 'PM'" (click)="onToggleAmPm('from', 'PM', $event)">PM</button>
              </div>
            </div>
          </div>

          <div class="time-arrow" aria-hidden="true">
            <span class="arrow-icon">→</span>
          </div>

          <!-- To Time -->
          <div class="time-selector to" 
               [class.active]="activeTimeSelector === 'to'"
               (click)="setActiveTimeSelector('to', $event)">
            <div class="time-label">End</div>
            <div class="time-row">
              <div class="time-inputs">
                <input 
                  type="text" 
                  class="time-input hour-input" 
                  [placeholder]="toTime.hour.toString().padStart(2, '0')"
                  maxlength="2"
                  (keydown)="onTimeInputKeydown($event, 'hour', 'to')"
                  (blur)="onTimeInputBlur($event, 'hour', 'to')"
                  (focus)="onTimeInputFocus($event, 'hour', 'to')"
                  (click)="$event.stopPropagation()">
                <span class="time-separator">:</span>
                <input 
                  type="text" 
                  class="time-input minute-input" 
                  [placeholder]="toTime.minute.toString().padStart(2, '0')"
                  maxlength="2"
                  (keydown)="onTimeInputKeydown($event, 'minute', 'to')"
                  (blur)="onTimeInputBlur($event, 'minute', 'to')"
                  (focus)="onTimeInputFocus($event, 'minute', 'to')"
                  (click)="$event.stopPropagation()">
              </div>
              <div class="am-pm-toggle" *ngIf="use12Hours">
                <button type="button" class="am" [class.active]="amPm.to === 'AM'" (click)="onToggleAmPm('to', 'AM', $event)">AM</button>
                <button type="button" class="pm" [class.active]="amPm.to === 'PM'" (click)="onToggleAmPm('to', 'PM', $event)">PM</button>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
    <div class="calendar-actions">
      <button type="button" class="cancel-btn" (click)="onCancel($event)">Cancel</button>
      <button type="button" class="apply-btn" (click)="onApply($event)">Apply</button>
    </div>

  </div>
</div>
